import { PerformanceDatapoint } from 'owa-analytics';

export default function createSonoraPerformanceDatapoint(
    datapointName: string,
    customData?: any
): PerformanceDatapoint {
    const performanceDatapoint = new PerformanceDatapoint(datapointName, {
        isCore: true,
        excludeFromKusto: true,
    });

    if (customData) {
        performanceDatapoint.addCustomData(customData);
    }

    return performanceDatapoint;
}
